import { useEffect, useState } from "react";

const QUERY = "(min-width: 768px)";

// Returns true when the viewport is at least `md` (768px) — same breakpoint as
// Tailwind's `md:` prefix. Used to gate bulk-select behaviour since it relies
// on hover, which doesn't exist on touch.
export function useIsDesktop(): boolean {
  const [wide, setWide] = useState<boolean>(() => {
    if (typeof window === "undefined") return true;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const handler = (): void => setWide(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return wide;
}
